import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbGuestPatientModal } from './guestpatient.modal';
import { ProviderAvlSlotsController, DoctorsListController, SaveAppointmentInformationRequest, PatientInfoByFormattedCodeController, SaveAppointmentInformationNewRequest } from '../../../../models/actor/actor';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NgbSearchPatientModal } from '../../follow up/counsellingregistry/modal/searchpatient.modal';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbregisteredpatient',
  templateUrl: './registeredpatient.modal.html',
  styleUrls: ['./registeredpatient.modal.scss']
})

export class NgbRegisteredPatientModal implements OnInit {
  public Patientlist: boolean = false;
  public GuestPatient: boolean = false;
  public Regconfirm: boolean = false;
  public Final: boolean = false;
  public isvisible: boolean = true;
    public Final1: boolean = false;
    public ActorCodeNew: number;
    public Typeofpatient: boolean = true;
    public SaveAppointmentRequest: SaveAppointmentInformationRequest;
    public SaveAppoinmentRequestNew: SaveAppointmentInformationNewRequest;
    public Regconfirm1: boolean = false;
    @Input()
    SelectedDoctor: DoctorsListController;
    @Input()
    ProviderAvlSlotsController: ProviderAvlSlotsController;

    constructor(public activeModal: NgbActiveModal,
        private actorservice: ActorService,
        private loaderService: SpinnerService,        
        private tosterservice: NGXToastrService,
        private parserFormatter: NgbDateParserFormatter,
        private modalService: NgbModal
    ) {
    }
  ngOnInit() {

      this.SaveAppointmentRequest = new SaveAppointmentInformationRequest();
      this.SaveAppoinmentRequestNew = new SaveAppointmentInformationNewRequest();
  }

 
  onSubmit() {

  }
  ModalClose() {
    this.activeModal.close();
  }
  regpatient() {

      this.SearchPatient();
      //this.Patientlist = true;
      //this.Typeofpatient = false;
      //this.Regconfirm = false;


  }
  regconfirm() {
    this.Patientlist = false;
    this.Typeofpatient = false;
    this.Regconfirm = true;
    
  }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    public ApiResData: ApiResponseModel;
    public isRequesting: boolean = false;
    //eranki
    SearchPatient() {
        const modalRef = this.modalService.open(NgbSearchPatientModal,
            {
                centered: true,
                size: 'lg'
            })
        modalRef.componentInstance.PATIENT_OBJ = true;
        modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
        modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
           // alert(val.DisplayName);
            
            this.SaveAppoinmentRequestNew.ActorCode = val.ActorCode;
            this.SaveAppoinmentRequestNew.FormattedCode = val.FormattedCode;
            this.SaveAppoinmentRequestNew.Age = parseInt(val.Age);
            this.SaveAppoinmentRequestNew.PatientName = val.DisplayName;
            this.SaveAppoinmentRequestNew.Email = val.Email;
            this.SaveAppoinmentRequestNew.Telephone = val.Telephone1;
            this.SaveAppoinmentRequestNew.Gender = val.Gender;
            this.ActorCodeNew = val.ActorCode;
            //alert(val.ActorCode);
            this.regconfirm1();
          //  this.SaveAppt_SelectedPatient();
            //modalRef.result.
            ////alert(val);
            //const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
            //    {
            //        centered: true,
            //        size: 'lg'
            //    })
            //modalRef.componentInstance.FormattedCode = val;
            //modalRef.result.then(x => { this.GetCounsellingPlanController() })
        });

    }
   
    SaveAppt_SelectedPatient() {
      this.StartRefreshing();
      this.isvisible = false;
        //alert(this.ActorCodeNew);
        this.SaveAppoinmentRequestNew.ActorCode = 0;
        this.SaveAppoinmentRequestNew.ConditionalOperator = 10;
        this.SaveAppoinmentRequestNew.SessionCode = this.ProviderAvlSlotsController.session;
        this.SaveAppoinmentRequestNew.wod = this.ProviderAvlSlotsController.wod;
        this.SaveAppoinmentRequestNew.ProviderCode = this.ProviderAvlSlotsController.provider;
        this.SaveAppoinmentRequestNew.Date = this.ProviderAvlSlotsController.StartDateShort;
        this.SaveAppoinmentRequestNew.StartTime = this.ProviderAvlSlotsController.StartDate;
        this.SaveAppoinmentRequestNew.LocationCode = this.ProviderAvlSlotsController.facility;
        this.SaveAppoinmentRequestNew.Specialty = "";//this.SelectedDoctor.Specialty;
      this.SaveAppoinmentRequestNew.ProviderName = this.SelectedDoctor.DisplayName;
      this.SaveAppoinmentRequestNew.SlotNumber = this.ProviderAvlSlotsController.SlotNo;
        this.SaveAppoinmentRequestNew.FormattedCode = "";
        //this.SaveAppointmentRequest.LocationCode
        this.SaveAppoinmentRequestNew.AppointmentStatus = "";
        this.SaveAppoinmentRequestNew.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        // alert(this.SaveAppointmentRequest.LocationCode);
        this.actorservice.SaveAppointmentInformationNew2(this.SaveAppoinmentRequestNew)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
                    //     this.CurrentDoctorsListController = this.ApiResData.Result;
                    //    this.pdata = this.CurrentDoctorsListController;
                    //alert(this.CurrentServiceCategoriesController.length);

                    this.stopRefreshing();
                    this.Patientlist = false;
                    this.Regconfirm = false;
                    this.Final1 = true;
                    this.Typeofpatient = false;
                    this.Regconfirm1 = false;

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
  SaveAppt() {
    this.isvisible = false;
    this.StartRefreshing();
    this.SaveAppoinmentRequestNew.ActorCode = this.ActorCodeNew ? this.ActorCodeNew : 0;
    this.SaveAppoinmentRequestNew.ConditionalOperator = 10;
    this.SaveAppoinmentRequestNew.SessionCode = this.ProviderAvlSlotsController.session;
    this.SaveAppoinmentRequestNew.wod = this.ProviderAvlSlotsController.wod;
    this.SaveAppoinmentRequestNew.ProviderCode = this.ProviderAvlSlotsController.provider;
    this.SaveAppoinmentRequestNew.Date = this.ProviderAvlSlotsController.StartDateShort;
    this.SaveAppoinmentRequestNew.StartTime = this.ProviderAvlSlotsController.StartDate;
    this.SaveAppoinmentRequestNew.LocationCode = this.ProviderAvlSlotsController.facility;
    this.SaveAppoinmentRequestNew.SlotNumber = this.ProviderAvlSlotsController.SlotNo;
    this.SaveAppoinmentRequestNew.Specialty = "";
    this.SaveAppoinmentRequestNew.ProviderName = this.SelectedDoctor ? this.SelectedDoctor.DisplayName : "";
    this.SaveAppoinmentRequestNew.FormattedCode = this.SaveAppoinmentRequestNew.FormattedCode || "";
    this.SaveAppoinmentRequestNew.PatientName = this.SaveAppoinmentRequestNew.PatientName || "";
    this.SaveAppoinmentRequestNew.Telephone = this.SaveAppoinmentRequestNew.Telephone || "";
    this.SaveAppoinmentRequestNew.Email = this.SaveAppoinmentRequestNew.Email || "";
    this.SaveAppoinmentRequestNew.Gender = this.SaveAppoinmentRequestNew.Gender || "";
    this.SaveAppoinmentRequestNew.VisitType = this.SaveAppoinmentRequestNew.VisitType || "";
    this.SaveAppoinmentRequestNew.ConsultationType = this.SaveAppoinmentRequestNew.ConsultationType || "";
    if (this.SaveAppoinmentRequestNew.Age) {
      this.SaveAppoinmentRequestNew.Age = parseInt(this.SaveAppoinmentRequestNew.Age as any, 10) || 0;
    } else {
      this.SaveAppoinmentRequestNew.Age = 0;
    }
    this.SaveAppoinmentRequestNew.AppointmentStatus = "";
    this.SaveAppoinmentRequestNew.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.SaveAppointmentInformationNew2(this.SaveAppoinmentRequestNew)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    //alert();
               //     this.CurrentDoctorsListController = this.ApiResData.Result;
                //    this.pdata = this.CurrentDoctorsListController;
                    //alert(this.CurrentServiceCategoriesController.length);

                    this.stopRefreshing();
                    this.Patientlist = false;
                    this.Regconfirm = false;
                    this.Final1 = true;
                    this.Typeofpatient = false;
                    this.Regconfirm1 = false;

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    regconfirm1() {

        this.SaveAppoinmentRequestNew.SessionCode = this.ProviderAvlSlotsController.session;
        this.SaveAppoinmentRequestNew.wod = this.ProviderAvlSlotsController.wod;
        this.SaveAppoinmentRequestNew.ProviderCode = this.ProviderAvlSlotsController.provider;
        this.SaveAppoinmentRequestNew.Date = this.ProviderAvlSlotsController.StartDateShort;
        this.SaveAppoinmentRequestNew.StartTime = this.ProviderAvlSlotsController.StartDate;
      this.SaveAppoinmentRequestNew.LocationCode = this.ProviderAvlSlotsController.facility;
      this.SaveAppoinmentRequestNew.SlotNumber = this.ProviderAvlSlotsController.SlotNo;
        this.SaveAppoinmentRequestNew.Specialty = "";//this.SelectedDoctor.Specialty;
        this.SaveAppoinmentRequestNew.ProviderName = this.SelectedDoctor.DisplayName;
        this.SaveAppoinmentRequestNew.FormattedCode = "";

        this.Patientlist = false;
        this.Typeofpatient = false;
        this.Regconfirm1 = true;
        this.Regconfirm = false;
        this.GuestPatient = false;
    
    }
    Confirm1() {
        // save booking..

        this.SaveAppt();

       
    }
    regconfirm2() {
  this.SaveAppointmentRequest.SessionCode = this.ProviderAvlSlotsController.session;
        this.SaveAppointmentRequest.wod = this.ProviderAvlSlotsController.wod;
        this.SaveAppointmentRequest.ProviderCode = this.ProviderAvlSlotsController.provider;
        this.SaveAppointmentRequest.Date = this.ProviderAvlSlotsController.StartDateShort;
        this.SaveAppointmentRequest.StartTime = this.ProviderAvlSlotsController.StartDate;
      this.SaveAppointmentRequest.LocationCode = this.ProviderAvlSlotsController.facility;
      this.SaveAppoinmentRequestNew.SlotNumber = this.ProviderAvlSlotsController.SlotNo;
        this.SaveAppointmentRequest.Specialty = "";//this.SelectedDoctor.Specialty;
        this.SaveAppointmentRequest.ProviderName = this.SelectedDoctor.DisplayName;
        this.SaveAppointmentRequest.FormattedCode = "";

        this.Patientlist = false;
        this.Typeofpatient = false;
        this.Regconfirm1 = true;
        this.Regconfirm = false;
        this.GuestPatient = false;
    }
    Confirm2() {
        // save booking..

        this.SaveAppt_SelectedPatient();


    }
    //SetStep(s1: boolean, s2: boolean, s3: boolean, s4: boolean, s5: boolean) {
    //    this.Patientlist = s1;
    //    this.Typeofpatient = s2;
    //    this.Regconfirm1 = s3;
    //    this.Regconfirm = s4;
    //    this.GuestPatient = s5;
    //}
    Back1() {

    this.Patientlist = false;
    this.Typeofpatient = true;
    this.Regconfirm1 = false;
    this.Regconfirm = false;
    this.GuestPatient = false;
  }
  Back2() {
    this.Patientlist = true;
    this.Typeofpatient = false;
    this.Regconfirm1 = false;
    this.Regconfirm = false;
    this.GuestPatient = false;
  }
  Back3() {
    this.Patientlist = false;
    this.Typeofpatient = true;
    this.Regconfirm1 = false;
    this.Regconfirm = false;
    this.GuestPatient = false;
  }
  BacktoList() {
    this.Patientlist = false;
    this.Typeofpatient = false;
    this.Regconfirm1 = false;
    this.Regconfirm = false;
    this.GuestPatient = false;
    this.Typeofpatient = true;
  }
  Confirm() {
    this.Patientlist = false;
    this.Regconfirm = false;
    this.Final = true;
  }

  guestpatient() {
    this.GuestPatient = true;
    this.Typeofpatient = false;
    this.Regconfirm = false;
    this.Patientlist = false;
  }
  
}
